import { Button } from "../ui"

interface RetryableErrorProps {
  error: string
  onRetry: () => void
  className?: string
}

export function RetryableError({ error, onRetry, className = "" }: RetryableErrorProps) {
  return (
    <div className={`rounded-lg border border-danger/30 bg-danger-soft p-4 ${className}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1">
          <h3 className="mb-1 text-sm font-semibold text-danger">Error</h3>
          <p className="text-sm text-foreground">{error}</p>
        </div>
        <Button variant="ghost" onClick={onRetry} className="shrink-0">
          Retry
        </Button>
      </div>
    </div>
  )
}
